/**
 * Слой дверей и окон на холсте. Проёмы лежат поверх стен и «прорезают» их белым;
 * каждый ставится в локальные координаты своей стены (начало проёма, ось вдоль стены).
 */
import type { PointerEvent } from "react";
import {
	openingsOfWall,
	pointAlongWall,
	type Opening,
	type Wall,
	type WallGraph,
} from "../../plan";
import { DoorShape, WindowShape } from "@/widgets/catalog";
import { SelectionKind, Tool, useEditorStore } from "@/widgets/editor";
import { angleOf, sub } from "@/shared/lib/geometry";

const DEG = 180 / Math.PI;

interface Props {
	graph: WallGraph;
	walls: Wall[];
	mmPerPx: number;
	onOpeningPointerDown: (e: PointerEvent<Element>, opening: Opening) => void;
}

export const OpeningsLayer2D = ({ graph, walls, mmPerPx, onOpeningPointerDown }: Props) => {
	const selection = useEditorStore((s) => s.selection);
	const tool = useEditorStore((s) => s.tool);

	return (
		<g>
			{walls.map((wall) => {
				const a = graph.nodes[wall.a];
				const b = graph.nodes[wall.b];
				if (!a || !b) return null;
				const deg = angleOf(sub(b, a)) * DEG;
				return openingsOfWall(graph, wall.id).map((opening) => {
					const start = pointAlongWall(a, b, opening.offset - opening.width / 2);
					// Как рисуется дверь или окно, знает раздел каталога
					const Shape = opening.kind === "door" ? DoorShape : WindowShape;
					return (
						<g key={opening.id} transform={`translate(${start.x} ${start.y}) rotate(${deg})`}>
							<Shape
								opening={opening}
								wallThickness={wall.thickness}
								selected={selection?.kind === SelectionKind.Opening && selection.id === opening.id}
								mmPerPx={mmPerPx}
								// Инструмент «Коммент.» тоже видит проём: к нему привязывают комментарий
								interactive={tool === Tool.Select || tool === Tool.Erase || tool === Tool.Comment}
								onPointerDown={(e) => onOpeningPointerDown(e, opening)}
							/>
						</g>
					);
				});
			})}
		</g>
	);
};
